import { makeQuery } from "../makeQuery";
import type { ApiToken } from "./tokens.types";

export const useQueryApiTokens = makeQuery<ApiToken[]>("/api/auth/tokens");
